import { useCallback, useState } from 'react';
import useAxiosPrivate from './useAxiosPrivate';
import useNotification from './useNotification';

/**
 * Xavfsiz hujjat yuklab olish:
 *  1) auth bilan /admin/downloads/prepare — server faylni tayyorlab
 *     bir martalik unikal havola qaytaradi
 *  2) brauzer shu havoladan faylni yuklab oladi, server faylni o'chiradi
 *
 * type: 'doc' | 'payment' | 'payment-table'
 * Token URL'da yuborilmaydi (eski /doc/{id}?token=... o'rniga).
 * Server xatosi (masalan, shablon yo'q) bildirishnoma sifatida ko'rsatiladi.
 */
export default function useSecureDownload() {
  const axiosPrivate = useAxiosPrivate();
  const sendNotification = useNotification();
  const [downloading, setDownloading] = useState(false);

  const download = useCallback(
    async (params) => {
      if (downloading) return;
      setDownloading(true);
      try {
        const res = await axiosPrivate.get('/admin/downloads/prepare', {
          params,
        });
        const link = res?.data?.data?.link;
        if (link) {
          window.location.href = `${process.env.REACT_APP_BACKEND_URL}${link}`;
        } else {
          sendNotification({
            msg: res?.data?.message || "Hujjatni tayyorlab bo'lmadi",
            variant: 'error',
          });
        }
      } catch (error) {
        sendNotification({
          msg:
            error?.response?.data?.message ||
            error?.message ||
            "Hujjatni yuklab bo'lmadi",
          variant: 'error',
        });
      } finally {
        setDownloading(false);
      }
    },
    [axiosPrivate, downloading, sendNotification]
  );

  return { download, downloading };
}
